const Hero = () => {
  return (
    <section className="relative pt-6 md:pt-10 pb-2 md:pb-4 px-4">
      {/* Animated background glow effects - extends beyond section */}
      <div className="absolute inset-x-0 -top-20 -bottom-32 pointer-events-none">
        {/* Primary glow orb */}
        <div 
          className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] rounded-full opacity-15 blur-[120px]"
          style={{ background: 'radial-gradient(ellipse, hsl(var(--primary)) 0%, transparent 60%)' }}
        />
        {/* Secondary accent glow */}
        <div 
          className="absolute top-1/3 left-1/4 -translate-y-1/2 w-[500px] h-[300px] rounded-full opacity-10 blur-[100px]"
          style={{ background: 'radial-gradient(ellipse, hsl(var(--secondary)) 0%, transparent 60%)' }}
        />
        {/* Right accent glow */}
        <div 
          className="absolute top-1/3 right-1/4 -translate-y-1/2 w-[500px] h-[300px] rounded-full opacity-10 blur-[100px]"
          style={{ background: 'radial-gradient(ellipse, hsl(var(--primary)) 0%, transparent 60%)' }}
        />
      </div>

      <div className="container mx-auto text-center relative z-10">
        <div className="animate-slide-up">

          {/* Label with glow */}
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-1 md:mb-2">
            <span className="inline-flex items-center gap-2">
              <span className="w-8 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
              Start Claiming
              <span className="w-8 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
            </span>
          </p>
          
          {/* Main heading with animated glow */}
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-black tracking-tight">
            <span 
              className="text-primary animate-text-glow inline-block"
              style={{ 
                textShadow: '0 0 40px hsl(var(--primary) / 0.5), 0 0 80px hsl(var(--primary) / 0.3), 0 0 120px hsl(var(--primary) / 0.2)'
              }}
            >
              VIP REWARDS
            </span>
          </h1>

          {/* Decorative underline */}
          <div className="mt-2 md:mt-3 flex justify-center">
            <div className="h-1 w-32 md:w-48 rounded-full bg-gradient-to-r from-transparent via-primary to-transparent opacity-60" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
